/**
 * Icon - Cross-platform Material Symbols icon component
 * Web: renders a <span> with Material Symbols CSS class
 * Native: renders a Text with loaded icon font
 */
import React from 'react';
import { Platform, Text } from 'react-native';

// Supported icon names (Material Symbols Outlined)
export type IconName =
  | 'home' | 'person' | 'notifications' | 'search' | 'add'
  | 'visibility' | 'visibility_off' | 'close' | 'chevron_right'
  | 'menu' | 'star' | 'arrow_back' | 'arrow_forward' | 'check_circle' | 'category'
  | 'location_on' | 'warning' | 'error' | 'description' | 'calendar_today'
  | 'open_in_new' | 'share' | 'filter_list' | 'lock' | 'smartphone'
  | 'fingerprint' | 'face' | 'send' | 'history' | 'settings'
  | 'phone' | 'mail' | 'save' | 'edit' | 'delete' | 'favorite'
  | 'favorite_border' | 'compare_arrows' | 'picture_as_pdf' | 'calculate'
  | 'list' | 'info' | 'help' | 'logout' | 'login' | 'chat' | 'circle' | 'shield'
  | 'payments' | 'trending_up' | 'medical_services' | 'health_and_safety'
  | 'school' | 'savings' | 'elderly' | 'monetization_on' | 'volunteer_activism'
  | 'local_fire_department' | 'workspace_premium' | 'trending_down'
  | 'verified' | 'workspace_premium';

interface IconProps {
  name: IconName;
  filled?: boolean;
  size?: number;
  color?: string;
  style?: object;
}

export const Icon: React.FC<IconProps> = ({
  name,
  filled = false,
  size = 24,
  color = '#1a1a1a',
  style,
}) => {
  const variation = filled ? "'FILL' 1,'wght' 400,'GRAD' 0,'opsz' 24" : "'FILL' 0,'wght' 400,'GRAD' 0,'opsz' 24";

  if (Platform.OS === 'web') {
    // Web: render as a <span> with Material Symbols class
    return (
      <Text
        // @ts-ignore - web-only prop
        suppressHydrationWarning
        style={[
          {
            fontFamily: "'Material Symbols Outlined', sans-serif",
            fontSize: size,
            lineHeight: size + 2,
            color,
            fontVariationSettings: variation,
            textAlign: 'center',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: size,
            height: size,
          },
          style,
        ]}
      >
        {name}
      </Text>
    );
  }

  // Native: render with system font family
  return (
    <Text
      style={[
        {
          fontFamily: 'System',
          fontSize: size,
          lineHeight: size + 2,
          color,
          textAlign: 'center',
        },
        style,
      ]}
    >
      {name}
    </Text>
  );
};
